import matter from "gray-matter";

const SHEET_ID = "1Qp2gSClxSu8AvdbVB4yK04xTvC0aIhNq";
const CSV_URL = `https://docs.google.com/spreadsheets/d/${SHEET_ID}/export?format=csv`;
const GVIZ_URL = `https://docs.google.com/spreadsheets/d/${SHEET_ID}/gviz/tq?tqx=out:json`;

export async function fetchFromCSV() {
  const r = await fetch(CSV_URL, { cache: "no-store" });
  if (!r.ok) throw new Error(`CSV HTTP ${r.status}`);
  return parseCSV(await r.text());
}

export async function fetchFromGViz() {
  const r = await fetch(GVIZ_URL, { cache: "no-store" });
  if (!r.ok) throw new Error(`GViz HTTP ${r.status}`);
  const text = await r.text();
  const json = JSON.parse(
    text.replace(/^.*setResponse\(/, "").replace(/\);\s*$/, "")
  );
  const headers = json.table.cols.map((c) => c.label || c.id);
  return json.table.rows.map((row) =>
    Object.fromEntries(
      headers.map((h, i) => [h, (row.c[i]?.v ?? "").toString()])
    )
  );
}

export async function loadArticlesFromSheet() {
  try {
    const a = await fetchFromCSV();
    if (a?.length) return a;
  } catch (e) {
    console.warn("[Ethira] CSV failed", e);
  }
  try {
    const a = await fetchFromGViz();
    if (a?.length) return a;
  } catch (e) {
    console.warn("[Ethira] GViz failed", e);
  }
  return [];
}

export function normaliseArticles(raw) {
  const arr = Array.isArray(raw) ? raw : [];

  const mapped = arr.map((x) => {
    // Try to pull a raw markdown body from the sheet if it exists
    const rawBody =
      x.body ||
      x.Body ||
      x.markdown ||
      x.Markdown ||
      x.content ||
      x.Content ||
      "";

    let frontmatter = {};
    let cleanedBody = rawBody;

    // If it looks like it starts with YAML front-matter, try to parse it
    if (rawBody && rawBody.trim().startsWith("---")) {
      try {
        const parsed = matter(rawBody);
        frontmatter = parsed.data || {};
        cleanedBody = parsed.content || "";
      } catch (e) {
        console.warn("[Ethira] front-matter parse failed", e);
      }
    }

    const tagsFromFM = Array.isArray(frontmatter.tags)
      ? frontmatter.tags.join(",")
      : frontmatter.tags || "";

    const article = {
      id: Number(x.id) || x.id || Math.random(),

      title: frontmatter.title || x.title || x.Title,
      excerpt:
        x.excerpt ||
        x.Excerpt ||
        frontmatter.description ||
        "",

      slug: (frontmatter.slug || x.slug || x.Slug || "").trim(),

      category:
        frontmatter.category ||
        x.category ||
        x.Category ||
        "Market Insights",

      date: frontmatter.date || x.date || x.Date,

      image:
        frontmatter.hero_image ||
        frontmatter.image ||
        x.image ||
        x.Image ||
        "",

      author: frontmatter.author || x.author || x.Author || "Ethira",

      status: x.status || x.Status || "Published",

      tags: x.tags || x.Tags || tagsFromFM,

      readTime: Number(x.readTime || x.ReadTime || 0),

      body_url: x.body_url || x.Body_Url || x.BodyURL || "",

      // body field (if you’re using it in the article page)
      body: cleanedBody,

      // keep all front-matter available if you ever want it later
      frontmatter,
    };

    return article;
  });

  return mapped.filter(
    (a) => (a.status || "").toLowerCase() === "published"
  );
}

// Tiny CSV parser
function parseCSV(text) {
  const rows = [];
  let row = [],
    cur = "",
    inQuotes = false;
  for (let i = 0; i < text.length; i++) {
    const c = text[i],
      n = text[i + 1];
    if (inQuotes) {
      if (c === '"' && n === '"') {
        cur += '"';
        i++;
      } else if (c === '"') {
        inQuotes = false;
      } else {
        cur += c;
      }
    } else {
      if (c === '"') inQuotes = true;
      else if (c === ",") {
        row.push(cur);
        cur = "";
      } else if (c === "\n" || c === "\r") {
        if (cur !== "" || row.length) {
          row.push(cur);
          rows.push(row);
          row = [];
          cur = "";
        }
        if (c === "\r" && n === "\n") i++;
      } else cur += c;
    }
  }
  if (cur !== "" || row.length) {
    row.push(cur);
    rows.push(row);
  }
  const headers = (rows.shift() || []).map((h) => h.trim());
  return rows
    .filter((r) => r.some((cell) => (cell || "").trim() !== ""))
    .map((r) =>
      Object.fromEntries(
        headers.map((h, i) => [h, (r[i] || "").trim()])
      )
    );
}
